module.exports = __webpack_public_path__ + "src/assets/img/kuzov1.2fd404c8.svg";